import { useState, useContext, memo, Fragment } from "react";
//Router
import { Link, useLocation } from "react-router-dom";

//React-bootstrap
import {
  Accordion,
  useAccordionButton,
  AccordionContext,
  Nav,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

import { useSelector } from "react-redux";
import * as SettingSelector from "../../../../store/setting/selectors";
import { useTranslation } from "react-i18next";

import RightArrow from "../../../custom/RightArrow";

import { BsFillBox2Fill, BsFillInboxesFill } from "react-icons/bs";

import { RiCoupon2Fill } from "react-icons/ri";

import { BsImages } from "react-icons/bs";

import { AiOutlineAppstoreAdd } from "react-icons/ai";

import { VscUngroupByRefType } from "react-icons/vsc";

import { SiCodereview } from "react-icons/si";

import { IoSettingsSharp } from "react-icons/io5";

import { MdInventory2 } from "react-icons/md";

import { MdWidgets } from "react-icons/md";

import { BiCategoryAlt } from "react-icons/bi";

import { BsFileSpreadsheetFill } from "react-icons/bs";

function CustomToggle({ children, eventKey, onClick }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, (active) =>
    onClick({ state: !active, eventKey: eventKey })
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <Link
      to="#"
      aria-expanded={isCurrentEventKey ? "true" : "false"}
      className="nav-link"
      role="button"
      onClick={(e) => {
        decoratedOnClick(isCurrentEventKey);
      }}
    >
      {children}
    </Link>
  );
}

const VerticalNav = memo(() => {
  const { t } = useTranslation();
  const [activeMenu, setActiveMenu] = useState(false);
  const [active, setActive] = useState("");

  // const [user] = useState(JSON.parse(localStorage.getItem("user")));

  let location = useLocation();

  const mode = useSelector(SettingSelector.theme_scheme_direction);

  return (
    <Fragment>
      <Accordion as="ul" className="navbar-nav iq-main-menu">
        <li className="nav-item static-item"></li>
        {/* {user?.role === 1 && (
          <li
            style={
              location.pathname === "/dashboard"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={` nav-item `}
          >
            <Link className={`nav-link`} aria-current="page" to="/dashboard">
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem1")}</Tooltip>}
              >
                <i className="icon">
                  <MdWidgets className="text-black" />
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem1")}
              </span>
            </Link>
          </li>
        )} */}

        { (
          <Accordion.Item
            as="li"
            eventKey="products"
            bsPrefix={`nav-item `}
            onClick={() => setActive("products")}
          >
            <CustomToggle
              eventKey="products"
              onClick={(activeKey) => setActiveMenu(activeKey)}
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem2.item1")}</Tooltip>}
              >
                <i className="icon">
                  <BsFillBox2Fill className="text-black" />
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem2.item1")}
              </span>
              <i className="right-icon">
                <RightArrow />
              </i>
            </CustomToggle>
            <Accordion.Collapse eventKey="products">
              <ul className="sub-nav">
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/product/productlist` ||
                    location.pathname.includes("/product/productlist")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/product/productlist">
                    <i className="icon svg-icon">
                      <BsFillInboxesFill />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem2.item2")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <BsFillInboxesFill />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem2.item2")}
                    </span>
                  </Link>
                </Nav.Item>
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/product/create` ||
                    location.pathname.includes("/product/create")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/product/create">
                    <i className="icon">
                      <AiOutlineAppstoreAdd />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem16.item2")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <AiOutlineAppstoreAdd />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem2.item3")}
                    </span>
                  </Link>
                </Nav.Item>

                {/* <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/product/varient-types` ||
                    location.pathname.includes("/product/varient-types")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/product/varient-types">
                    <i className="icon">
                      <VscUngroupByRefType />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem2.item4")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <VscUngroupByRefType />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem2.item4")}
                    </span>
                  </Link>
                </Nav.Item>
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/product/review` ||
                    location.pathname.includes("/product/review")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={`nav-link`} to="/product/review">
                    <i className="icon">
                      <SiCodereview />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem2.item5")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <SiCodereview />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem2.item5")}
                    </span>
                  </Link>
                </Nav.Item> */}
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}
        {/* {(
          <li
            style={
              location.pathname === "/pincodes"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={` nav-item `}
          >
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/pincodes"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>Pincodes</Tooltip>}
              >
                <i className="icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.80735 0.023495C3.77094 0.0338838 2.9222 0.724759 1.92126 1.55883C0.481501 2.75854 0.0900451 3.10248 0.0469547 3.20555C-0.0280519 3.38508 0.00315025 3.60982 0.125281 3.76997C0.305069 4.00566 0.261836 4.00138 2.33689 3.99046C4.16264 3.98085 4.20987 3.97885 4.30609 3.90699C4.36028 3.8665 4.43775 3.78903 4.47823 3.73481C4.55006 3.63859 4.55185 3.59689 4.55185 1.99923C4.55185 0.401563 4.55006 0.359864 4.47823 0.263652C4.3551 0.0987157 4.2293 0.0264224 4.04576 0.0151767C3.95105 0.00935758 3.84377 0.0131062 3.80735 0.023495ZM5.13348 1.86535L5.12306 3.7307L5.00107 3.95565C4.86558 4.20551 4.75441 4.31312 4.48427 4.4556L4.30195 4.55181L2.151 4.56206L4.43346e-05 4.5723V8.95464C4.43346e-05 13.7248 -0.00820242 13.5194 0.200252 13.9308C0.327774 14.1825 0.637832 14.4985 0.88795 14.6318C1.31046 14.8571 1.21707 14.8514 4.50962 14.8514C7.35001 14.8514 7.5032 14.8482 7.47418 14.7889C7.45736 14.7546 7.43916 13.0366 7.43373 10.9712C7.42266 6.75863 7.4132 6.93371 7.68053 6.3916C7.88784 5.97115 8.25605 5.6029 8.67646 5.3957C9.16838 5.15318 9.26977 5.14219 11.0226 5.14147L12.5666 5.14087V3.32764C12.5666 1.33452 12.5628 1.29275 12.347 0.887909C12.2137 0.637792 11.8977 0.327734 11.646 0.200212C11.2438 -0.0035659 11.3073 4.09103e-06 8.09804 4.09103e-06H5.1439L5.13348 1.86535ZM9.28615 5.76852C8.68271 5.93077 8.20939 6.41084 8.05021 7.02203C7.96917 7.33312 7.97045 14.3777 8.0516 14.6892C8.212 15.305 8.68782 15.7793 9.3069 15.9405C9.61124 16.0198 14.3795 16.0198 14.6839 15.9405C15.303 15.7793 15.7788 15.305 15.9392 14.6892C16.0203 14.3777 16.0216 7.33312 15.9406 7.02203C15.7793 6.40295 15.305 5.92713 14.6893 5.76673C14.3855 5.68762 9.58108 5.68919 9.28615 5.76852ZM6.28332 7.42569V7.9969H3.99849H1.71367V7.42569V6.85449H3.99849H6.28332V7.42569ZM13.709 8.56811V9.13932H11.9954H10.2818V8.56811V7.9969H11.9954H13.709V8.56811ZM6.28332 10.2817V10.8529H3.99849H1.71367V10.2817V9.71052H3.99849H6.28332V10.2817ZM11.4242 10.8529V11.4241H10.853H10.2818V10.8529V10.2817H10.853H11.4242V10.8529ZM13.709 10.8529V11.4241H13.1378H12.5666V10.8529V10.2817H13.1378H13.709V10.8529ZM11.4242 13.1378V13.709H10.853H10.2818V13.1378V12.5666H10.853H11.4242V13.1378ZM13.709 13.1378V13.709H13.1378H12.5666V13.1378V12.5666H13.1378H13.709V13.1378Z"
                      fill="black"
                    />
                  </svg>
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                Pincodes
              </span>
            </Link>
          </li>
        )} */}
        { (
          <li
            style={
              location.pathname === "/category/categoryList"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={` nav-item `}
          >
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/category/categoryList"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem4")}</Tooltip>}
              >
                <i className="icon">
                  <BiCategoryAlt />
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem4")}{" "}
              </span>
            </Link>
          </li>
        )}

        { (
          <li
            style={
              location.pathname === "/brand/brandlist"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={` nav-item `}
          >
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/brand/brandlist"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem5")}</Tooltip>}
              >
                <i className="icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.80735 0.023495C3.77094 0.0338838 2.9222 0.724759 1.92126 1.55883C0.481501 2.75854 0.0900451 3.10248 0.0469547 3.20555C-0.0280519 3.38508 0.00315025 3.60982 0.125281 3.76997C0.305069 4.00566 0.261836 4.00138 2.33689 3.99046C4.16264 3.98085 4.20987 3.97885 4.30609 3.90699C4.36028 3.8665 4.43775 3.78903 4.47823 3.73481C4.55006 3.63859 4.55185 3.59689 4.55185 1.99923C4.55185 0.401563 4.55006 0.359864 4.47823 0.263652C4.3551 0.0987157 4.2293 0.0264224 4.04576 0.0151767C3.95105 0.00935758 3.84377 0.0131062 3.80735 0.023495ZM5.13348 1.86535L5.12306 3.7307L5.00107 3.95565C4.86558 4.20551 4.75441 4.31312 4.48427 4.4556L4.30195 4.55181L2.151 4.56206L4.43346e-05 4.5723V8.95464C4.43346e-05 13.7248 -0.00820242 13.5194 0.200252 13.9308C0.327774 14.1825 0.637832 14.4985 0.88795 14.6318C1.31046 14.8571 1.21707 14.8514 4.50962 14.8514C7.35001 14.8514 7.5032 14.8482 7.47418 14.7889C7.45736 14.7546 7.43916 13.0366 7.43373 10.9712C7.42266 6.75863 7.4132 6.93371 7.68053 6.3916C7.88784 5.97115 8.25605 5.6029 8.67646 5.3957C9.16838 5.15318 9.26977 5.14219 11.0226 5.14147L12.5666 5.14087V3.32764C12.5666 1.33452 12.5628 1.29275 12.347 0.887909C12.2137 0.637792 11.8977 0.327734 11.646 0.200212C11.2438 -0.0035659 11.3073 4.09103e-06 8.09804 4.09103e-06H5.1439L5.13348 1.86535ZM9.28615 5.76852C8.68271 5.93077 8.20939 6.41084 8.05021 7.02203C7.96917 7.33312 7.97045 14.3777 8.0516 14.6892C8.212 15.305 8.68782 15.7793 9.3069 15.9405C9.61124 16.0198 14.3795 16.0198 14.6839 15.9405C15.303 15.7793 15.7788 15.305 15.9392 14.6892C16.0203 14.3777 16.0216 7.33312 15.9406 7.02203C15.7793 6.40295 15.305 5.92713 14.6893 5.76673C14.3855 5.68762 9.58108 5.68919 9.28615 5.76852ZM6.28332 7.42569V7.9969H3.99849H1.71367V7.42569V6.85449H3.99849H6.28332V7.42569ZM13.709 8.56811V9.13932H11.9954H10.2818V8.56811V7.9969H11.9954H13.709V8.56811ZM6.28332 10.2817V10.8529H3.99849H1.71367V10.2817V9.71052H3.99849H6.28332V10.2817ZM11.4242 10.8529V11.4241H10.853H10.2818V10.8529V10.2817H10.853H11.4242V10.8529ZM13.709 10.8529V11.4241H13.1378H12.5666V10.8529V10.2817H13.1378H13.709V10.8529ZM11.4242 13.1378V13.709H10.853H10.2818V13.1378V12.5666H10.853H11.4242V13.1378ZM13.709 13.1378V13.709H13.1378H12.5666V13.1378V12.5666H13.1378H13.709V13.1378Z"
                      fill="black"
                    />
                  </svg>
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem5")}
              </span>
            </Link>
          </li>
        )}

        <li
          style={
            location.pathname === "/order/orderList"
              ? { background: "#CCDAE0", borderRadius: "6px" }
              : {}
          }
          className={` nav-item `}
        >
          <Link
            className={`nav-link`}
            aria-current="page"
            to="/order/orderList"
          >
            <OverlayTrigger
              placement={mode === "ltr" ? "right" : "left"}
              overlay={<Tooltip>{t("sidebar.sidebarItem6")}</Tooltip>}
            >
              <i className="icon">
                <BsFileSpreadsheetFill color="black" />
              </i>
            </OverlayTrigger>
            <span
              className="item-name text-black"
              style={{ fontWeight: "600" }}
            >
              {t("sidebar.sidebarItem6")}{" "}
            </span>
          </Link>
        </li>
        
          <li
            style={
              location.pathname === "/staffs"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={` nav-item `}
          >
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/staffs"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>Staffs</Tooltip>}
              >
                <i className="icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.80735 0.023495C3.77094 0.0338838 2.9222 0.724759 1.92126 1.55883C0.481501 2.75854 0.0900451 3.10248 0.0469547 3.20555C-0.0280519 3.38508 0.00315025 3.60982 0.125281 3.76997C0.305069 4.00566 0.261836 4.00138 2.33689 3.99046C4.16264 3.98085 4.20987 3.97885 4.30609 3.90699C4.36028 3.8665 4.43775 3.78903 4.47823 3.73481C4.55006 3.63859 4.55185 3.59689 4.55185 1.99923C4.55185 0.401563 4.55006 0.359864 4.47823 0.263652C4.3551 0.0987157 4.2293 0.0264224 4.04576 0.0151767C3.95105 0.00935758 3.84377 0.0131062 3.80735 0.023495ZM5.13348 1.86535L5.12306 3.7307L5.00107 3.95565C4.86558 4.20551 4.75441 4.31312 4.48427 4.4556L4.30195 4.55181L2.151 4.56206L4.43346e-05 4.5723V8.95464C4.43346e-05 13.7248 -0.00820242 13.5194 0.200252 13.9308C0.327774 14.1825 0.637832 14.4985 0.88795 14.6318C1.31046 14.8571 1.21707 14.8514 4.50962 14.8514C7.35001 14.8514 7.5032 14.8482 7.47418 14.7889C7.45736 14.7546 7.43916 13.0366 7.43373 10.9712C7.42266 6.75863 7.4132 6.93371 7.68053 6.3916C7.88784 5.97115 8.25605 5.6029 8.67646 5.3957C9.16838 5.15318 9.26977 5.14219 11.0226 5.14147L12.5666 5.14087V3.32764C12.5666 1.33452 12.5628 1.29275 12.347 0.887909C12.2137 0.637792 11.8977 0.327734 11.646 0.200212C11.2438 -0.0035659 11.3073 4.09103e-06 8.09804 4.09103e-06H5.1439L5.13348 1.86535ZM9.28615 5.76852C8.68271 5.93077 8.20939 6.41084 8.05021 7.02203C7.96917 7.33312 7.97045 14.3777 8.0516 14.6892C8.212 15.305 8.68782 15.7793 9.3069 15.9405C9.61124 16.0198 14.3795 16.0198 14.6839 15.9405C15.303 15.7793 15.7788 15.305 15.9392 14.6892C16.0203 14.3777 16.0216 7.33312 15.9406 7.02203C15.7793 6.40295 15.305 5.92713 14.6893 5.76673C14.3855 5.68762 9.58108 5.68919 9.28615 5.76852ZM6.28332 7.42569V7.9969H3.99849H1.71367V7.42569V6.85449H3.99849H6.28332V7.42569ZM13.709 8.56811V9.13932H11.9954H10.2818V8.56811V7.9969H11.9954H13.709V8.56811ZM6.28332 10.2817V10.8529H3.99849H1.71367V10.2817V9.71052H3.99849H6.28332V10.2817ZM11.4242 10.8529V11.4241H10.853H10.2818V10.8529V10.2817H10.853H11.4242V10.8529ZM13.709 10.8529V11.4241H13.1378H12.5666V10.8529V10.2817H13.1378H13.709V10.8529ZM11.4242 13.1378V13.709H10.853H10.2818V13.1378V12.5666H10.853H11.4242V13.1378ZM13.709 13.1378V13.709H13.1378H12.5666V13.1378V12.5666H13.1378H13.709V13.1378Z"
                      fill="black"
                    />
                  </svg>
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                Staffs
              </span>
            </Link>
          </li>
        
        {/*{user?.role === 1 && (
          <Accordion.Item
            as="li"
            eventKey="returned"
            bsPrefix={`nav-item `}
            onClick={() => setActive("returned")}
          >
            <CustomToggle
              eventKey="returned"
              onClick={(activeKey) => setActiveMenu(activeKey)}
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem16.item1")}</Tooltip>}
              >
                <i className="icon">
                  <BsFillBox2Fill className="text-black" />
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem16.item1")}
              </span>
              <i className="right-icon">
                <RightArrow />
              </i>
            </CustomToggle>
            <Accordion.Collapse eventKey="returned">
              <ul className="sub-nav">
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/returnedorder/request` ||
                    location.pathname.includes("/returnedorder/request")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/returnedorder/request">
                    <i className="icon svg-icon">
                      <BsFillInboxesFill />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem16.item2")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <BsFillInboxesFill />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem16.item2")}
                    </span>
                  </Link>
                </Nav.Item>
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/returnedorder/orders` ||
                    location.pathname.includes("/returnedorder/orders")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/returnedorder/orders">
                    <i className="icon">
                      <AiOutlineAppstoreAdd />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem16.item3")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <AiOutlineAppstoreAdd />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem16.item3")}
                    </span>
                  </Link>
                </Nav.Item>
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}
        {user?.role === 1 && (
          <li
            style={
              location.pathname.includes(`/customer/customerList`) ||
              location.pathname === "/customer/customerList"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={`nav-item `}
          >
            <Link
              className={`nav-link `}
              aria-current="page"
              to="/customer/customerList"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem7")}</Tooltip>}
              >
                <i className="icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.96444 0.0546875C5.96206 0.08475 5.9515 0.339469 5.941 0.620719L5.92188 1.13203L5.59375 1.248C5.41328 1.31181 5.11094 1.43647 4.92188 1.52503L4.57812 1.68609L4.17947 1.28859L3.78084 0.891125L2.33597 2.33597L0.891125 3.78084L1.29203 4.18266L1.69297 4.58447L1.58472 4.80003C1.45019 5.068 1.30494 5.41672 1.20859 5.70312L1.135 5.92188L0.622187 5.941C0.340156 5.9515 0.08475 5.96206 0.0546875 5.96444C0.00321875 5.9685 0 6.08797 0 8C0 9.91203 0.00321875 10.0315 0.0546875 10.0356C0.08475 10.0379 0.339469 10.0485 0.620719 10.059L1.13203 10.0781L1.248 10.4062C1.31181 10.5867 1.43647 10.8891 1.52503 11.0781L1.68609 11.4219L1.28859 11.8205L0.891125 12.2192L2.33597 13.664L3.78084 15.1089L4.18266 14.708L4.58447 14.307L4.80003 14.4153C5.068 14.5498 5.41672 14.6951 5.70312 14.7914L5.92188 14.865L5.941 15.3778C5.9515 15.6598 5.96206 15.9152 5.96444 15.9453C5.9685 15.9968 6.08797 16 8 16C9.91203 16 10.0315 15.9968 10.0356 15.9453C10.0379 15.9152 10.0485 15.6605 10.059 15.3793L10.0781 14.868L10.4065 14.7525C10.5871 14.689 10.8888 14.5635 11.0769 14.4737L11.4188 14.3103L11.819 14.7096L12.2192 15.1089L13.664 13.664L15.1089 12.2192L14.708 11.8173L14.307 11.4155L14.4153 11.2C14.5498 10.932 14.6951 10.5833 14.7914 10.2969L14.865 10.0781L15.3778 10.059C15.6598 10.0485 15.9152 10.0379 15.9453 10.0356C15.9968 10.0315 16 9.91203 16 8C16 6.08797 15.9968 5.9685 15.9453 5.96444C15.9152 5.96206 15.6605 5.9515 15.3793 5.941L14.868 5.92188L14.752 5.59375C14.6882 5.41328 14.5635 5.11094 14.475 4.92188L14.3139 4.57812L14.7114 4.17947L15.1089 3.78084L13.664 2.33597L12.2192 0.891125L11.819 1.29041L11.4188 1.68966L11.0769 1.52631C10.8888 1.43647 10.5871 1.311 10.4065 1.2475L10.0781 1.13203L10.059 0.620719C10.0485 0.339469 10.0379 0.08475 10.0356 0.0546875C10.0315 0.00321875 9.91203 0 8 0C6.08797 0 5.9685 0.00321875 5.96444 0.0546875ZM8.29688 3.03084C9.05216 3.07253 9.57322 3.20837 10.2201 3.53225C10.7333 3.78922 11.0746 4.03906 11.5177 4.48225C12.2127 5.17719 12.6101 5.87878 12.8641 6.85938C12.9507 7.19359 12.9531 7.22519 12.9531 8C12.9531 8.76144 12.9494 8.81147 12.8695 9.125C12.6193 10.1064 12.2171 10.8184 11.5177 11.5177C10.8236 12.2119 10.0979 12.6226 9.13178 12.868C8.81047 12.9497 8.76456 12.9531 8 12.9531C7.22394 12.9531 7.19416 12.9508 6.85984 12.8637C6.214 12.6954 5.71119 12.4729 5.20166 12.1299C4.17384 11.4379 3.45231 10.3928 3.13197 9.13178C3.05028 8.81031 3.04688 8.76491 3.04706 8C3.04725 7.26597 3.05313 7.17972 3.12144 6.90625C3.35309 5.97891 3.75813 5.23031 4.38141 4.5775C5.21816 3.70109 6.31175 3.15631 7.48438 3.03172C7.60469 3.01894 7.71719 3.00694 7.73438 3.00503C7.75156 3.00313 8.00469 3.01475 8.29688 3.03084ZM5.1875 5.70312V6.25H6.55681C8.06822 6.25 8.10919 6.25434 8.39534 6.44559C8.52981 6.53547 8.75 6.80425 8.75 6.87853C8.75 6.89434 7.98413 6.90625 6.96875 6.90625H5.1875V7.28125V7.65625H6.96875C7.94844 7.65625 8.75 7.66384 8.75 7.67312C8.75 7.68241 8.72306 7.74216 8.69016 7.80594C8.61334 7.95469 8.42887 8.12959 8.25 8.22325L8.10938 8.29688L6.64844 8.30584L5.1875 8.31484L5.18806 8.86834L5.18866 9.42188L6.75828 10.6641L8.32794 11.9062L9.23428 11.9052C9.95238 11.9045 10.1306 11.8963 10.0925 11.8662C10.066 11.8452 9.37078 11.2867 8.5475 10.625L7.05066 9.42188L7.65816 9.40253C8.07809 9.38913 8.32291 9.36709 8.45122 9.33106C9.30709 9.09081 9.83397 8.55497 10.0135 7.74219L10.0324 7.65625H10.3131H10.5938V7.28125V6.90625H10.3131H10.0324L10.0134 6.82031C9.95266 6.54522 9.81388 6.21131 9.6835 6.02644C9.65131 5.98081 9.625 5.93509 9.625 5.92487C9.625 5.91462 9.84297 5.90625 10.1094 5.90625H10.5938V5.53125V5.15625H7.89062H5.1875V5.70312Z"
                      fill="black"
                    />
                  </svg>
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem7")}
              </span>
            </Link>
          </li>
        )}

        {user?.role === 1 && (
          <li
            style={
              location.pathname === "/usermanagment/usermanagmentlist"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={` nav-item `}
          >
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/usermanagment/usermanagmentlist"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem8")}</Tooltip>}
              >
                <i className="icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.80735 0.023495C3.77094 0.0338838 2.9222 0.724759 1.92126 1.55883C0.481501 2.75854 0.0900451 3.10248 0.0469547 3.20555C-0.0280519 3.38508 0.00315025 3.60982 0.125281 3.76997C0.305069 4.00566 0.261836 4.00138 2.33689 3.99046C4.16264 3.98085 4.20987 3.97885 4.30609 3.90699C4.36028 3.8665 4.43775 3.78903 4.47823 3.73481C4.55006 3.63859 4.55185 3.59689 4.55185 1.99923C4.55185 0.401563 4.55006 0.359864 4.47823 0.263652C4.3551 0.0987157 4.2293 0.0264224 4.04576 0.0151767C3.95105 0.00935758 3.84377 0.0131062 3.80735 0.023495ZM5.13348 1.86535L5.12306 3.7307L5.00107 3.95565C4.86558 4.20551 4.75441 4.31312 4.48427 4.4556L4.30195 4.55181L2.151 4.56206L4.43346e-05 4.5723V8.95464C4.43346e-05 13.7248 -0.00820242 13.5194 0.200252 13.9308C0.327774 14.1825 0.637832 14.4985 0.88795 14.6318C1.31046 14.8571 1.21707 14.8514 4.50962 14.8514C7.35001 14.8514 7.5032 14.8482 7.47418 14.7889C7.45736 14.7546 7.43916 13.0366 7.43373 10.9712C7.42266 6.75863 7.4132 6.93371 7.68053 6.3916C7.88784 5.97115 8.25605 5.6029 8.67646 5.3957C9.16838 5.15318 9.26977 5.14219 11.0226 5.14147L12.5666 5.14087V3.32764C12.5666 1.33452 12.5628 1.29275 12.347 0.887909C12.2137 0.637792 11.8977 0.327734 11.646 0.200212C11.2438 -0.0035659 11.3073 4.09103e-06 8.09804 4.09103e-06H5.1439L5.13348 1.86535ZM9.28615 5.76852C8.68271 5.93077 8.20939 6.41084 8.05021 7.02203C7.96917 7.33312 7.97045 14.3777 8.0516 14.6892C8.212 15.305 8.68782 15.7793 9.3069 15.9405C9.61124 16.0198 14.3795 16.0198 14.6839 15.9405C15.303 15.7793 15.7788 15.305 15.9392 14.6892C16.0203 14.3777 16.0216 7.33312 15.9406 7.02203C15.7793 6.40295 15.305 5.92713 14.6893 5.76673C14.3855 5.68762 9.58108 5.68919 9.28615 5.76852ZM6.28332 7.42569V7.9969H3.99849H1.71367V7.42569V6.85449H3.99849H6.28332V7.42569ZM13.709 8.56811V9.13932H11.9954H10.2818V8.56811V7.9969H11.9954H13.709V8.56811ZM6.28332 10.2817V10.8529H3.99849H1.71367V10.2817V9.71052H3.99849H6.28332V10.2817ZM11.4242 10.8529V11.4241H10.853H10.2818V10.8529V10.2817H10.853H11.4242V10.8529ZM13.709 10.8529V11.4241H13.1378H12.5666V10.8529V10.2817H13.1378H13.709V10.8529ZM11.4242 13.1378V13.709H10.853H10.2818V13.1378V12.5666H10.853H11.4242V13.1378ZM13.709 13.1378V13.709H13.1378H12.5666V13.1378V12.5666H13.1378H13.709V13.1378Z"
                      fill="black"
                    />
                  </svg>
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem8")}
              </span>
            </Link>
          </li>
        )}

        {user?.role === 1 && (
          <li
            style={
              location.pathname.includes(`/warehouse/warehouselist`) ||
              location.pathname === "/warehouse/warehouselist"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={`nav-item `}
          >
            <Link
              className={`nav-link `}
              aria-current="page"
              to="/warehouse/warehouselist"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem9")}</Tooltip>}
              >
                <i className="icon svg-icon">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 56 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M20.4427 0.0533751C17.0701 0.356873 13.4636 1.69442 10.7123 3.6622C8.81366 5.02001 6.80041 7.13006 5.54069 9.08242C0.446321 16.9775 1.52317 27.3587 8.12949 34.0379C9.69471 35.6204 12.0149 37.2665 13.637 37.9452L14.1634 38.1654L18.9711 35.1138C21.6154 33.4353 24.0788 31.9027 24.4455 31.7077C25.8784 30.9459 27.5641 30.9422 29.1438 31.6975C29.879 32.049 30.1995 32.3181 31.9325 34.0391L33.8905 35.9837L34.5202 35.4999C34.8665 35.234 35.5698 34.595 36.0831 34.0802C43.5661 26.5752 43.97 14.7898 37.0198 6.74717C33.9973 3.24968 29.383 0.752432 24.8726 0.173078C23.539 0.00172771 21.5987 -0.0506906 20.4427 0.0533751ZM43.5229 25.966C43 26.1336 42.2888 26.8787 42.1251 27.4306C41.7577 28.6687 42.0196 29.1892 44.0447 31.2445L45.6495 32.8732L36.1397 42.4494L32.1469 38.4339C29.4416 35.7133 28.0228 34.3639 27.7473 34.2494C27.2634 34.0481 26.3629 34.0285 25.9661 34.2105C25.8099 34.2822 20.061 37.8435 13.1908 42.1247C1.57829 49.3609 0.677878 49.9436 0.389881 50.4076C0.219577 50.6822 0.0531006 51.1098 0.0200679 51.3579C-0.213567 53.1118 1.63812 54.5308 3.21538 53.8067C3.45602 53.6962 5.81862 52.2538 8.46561 50.6016C11.1126 48.9493 14.3549 46.9285 15.6708 46.1112C16.9866 45.2939 19.9615 43.4402 22.2816 41.992L26.4999 39.3589L30.7724 43.6421C34.7831 47.6629 35.0772 47.9333 35.5721 48.0542C36.1412 48.1932 36.7115 48.1314 37.2325 47.8745C37.413 47.7854 40.1317 45.1299 43.2741 41.9732L48.9876 36.2338L50.6048 37.849C52.6455 39.8873 53.1628 40.1512 54.3924 39.7813C54.9736 39.6065 55.683 38.8922 55.8566 38.3072C56.0478 37.6632 56.0478 28.0746 55.8566 27.4306C55.6839 26.8485 54.9414 26.0945 54.3888 25.9401C53.8017 25.7759 44.0431 25.7991 43.5229 25.966Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.5946 16.5059H20.6223C21.7375 16.5059 22.8156 16.5539 23.0179 16.6126C23.3805 16.7179 23.8918 17.1145 23.8918 17.2906C23.8918 17.3403 22.6999 17.381 21.2432 17.381H18.5946V18.5843H21.2432C22.7645 18.5843 23.8918 18.6267 23.8918 18.6839C23.8918 18.7387 23.742 18.911 23.5591 19.0668L23.2266 19.35H18.5946V21.3091L23.1545 25.0382H26.2896L21.8304 21.3737L22.7051 21.2983C23.1862 21.2569 23.828 21.1396 24.1312 21.0376C24.8899 20.7828 25.7482 19.9261 26.0139 19.1586C26.2062 18.6031 26.2261 18.5843 26.6198 18.5843H27.0268V17.381H26.6115C26.2162 17.381 26.1898 17.3587 26.0617 16.9161C25.9876 16.6605 25.8572 16.3405 25.7718 16.2051L25.6165 15.9589H27.0268V14.6463H18.5946V16.5059Z"
                      fill="white"
                    />
                  </svg>
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem9")}{" "}
              </span>
            </Link>
          </li>
        )}

        {user?.role === 1 && (
          <li
            style={
              location.pathname === "/inventory/inventorylist"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={` nav-item `}
          >
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/inventory/inventorylist"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem10")}</Tooltip>}
              >
                <i className="icon">
                  <MdInventory2 className="text-dark" />
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem10")}
              </span>
            </Link>
          </li>
        )}

         {user?.role === 1 && ( 
          <Accordion.Item
            as="li"
            eventKey="offers"
            bsPrefix={`nav-item `}
            onClick={() => setActive("offers")}
          >
            <CustomToggle
              eventKey="offers"
              onClick={(activeKey) => setActiveMenu(activeKey)}
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem2.item1")}</Tooltip>}
              >
                <i className="icon">
                  <BsFillBox2Fill className="text-black" />
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem15.item1")}
              </span>
              <i className="right-icon">
                <RightArrow />
              </i>
            </CustomToggle>
            <Accordion.Collapse eventKey="offers">
              <ul className="sub-nav">
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/offer/offerlist` ||
                    location.pathname.includes("/offer/offerlist")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/offer/offerlist">
                    <i className="icon svg-icon">
                      <BsFillInboxesFill />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem15.item2")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <BsFillInboxesFill />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem15.item2")}
                    </span>
                  </Link>
                </Nav.Item>
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/offer/offerbannerlist` ||
                    location.pathname.includes("/offer/offerbannerlist")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/offer/offerbannerlist">
                    <i className="icon">
                      <AiOutlineAppstoreAdd />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem15.item3")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <AiOutlineAppstoreAdd />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem15.item3")}
                    </span>
                  </Link>
                </Nav.Item>

                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/offer/offercountdownlist` ||
                    location.pathname.includes("/offer/offercountdownlist")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/offer/offercountdownlist">
                    <i className="icon">
                      <VscUngroupByRefType />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem15.item4")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <VscUngroupByRefType />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem15.item4")}
                    </span>
                  </Link>
                </Nav.Item>

                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/offer/volumeofferslist` ||
                    location.pathname.includes("/offer/volumeofferslist")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/offer/volumeofferslist">
                    <i className="icon">
                      <VscUngroupByRefType />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem15.item5")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <VscUngroupByRefType />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem15.item5")}
                    </span>
                  </Link>
                </Nav.Item>
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}

        {user?.role === 1 && (
          <Accordion.Item
            as="li"
            eventKey="reports"
            bsPrefix={`nav-item `}
            onClick={() => setActive("reports")}
          >
            <CustomToggle
              eventKey="reports"
              onClick={(activeKey) => setActiveMenu(activeKey)}
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem17.item1")}</Tooltip>}
              >
                <i className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-bar-chart-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z" />
                  </svg>
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem17.item1")}
              </span>
              <i className="right-icon">
                <RightArrow />
              </i>
            </CustomToggle>
            <Accordion.Collapse eventKey="reports">
              <ul className="sub-nav">
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/reports/sales-report` ||
                    location.pathname.includes("/reports/sales-report")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/reports/sales-report">
                    <i className="icon svg-icon">
                      <BsFillInboxesFill />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem17.item2")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <BsFillInboxesFill />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem17.item2")}
                    </span>
                  </Link>
                </Nav.Item>
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/reports/stock-report` ||
                    location.pathname.includes("/reports/stock-report")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/reports/stock-report">
                    <i className="icon">
                      <AiOutlineAppstoreAdd />
                    </i>
                    <OverlayTrigger
                      placement={mode === "ltr" ? "right" : "left"}
                      overlay={
                        <Tooltip>{t("sidebar.sidebarItem17.item3")}</Tooltip>
                      }
                    >
                      <i className="sidenav-mini-icon">
                        <AiOutlineAppstoreAdd />
                      </i>
                    </OverlayTrigger>
                    <span
                      className="item-name text-black"
                      style={{ fontWeight: "600" }}
                    >
                      {t("sidebar.sidebarItem17.item3")}
                    </span>
                  </Link>
                </Nav.Item>
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}

        {user?.role === 1 && (
          <li
            style={
              location.pathname === "/coupons/coupon"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={` nav-item `}
          >
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/coupons/coupon"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem14")}</Tooltip>}
              >
                <i className="icon">
                  <RiCoupon2Fill className="text-black" />
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem14")}
              </span>
            </Link>
          </li>
        )}

        {user?.role === 1 && (
          <li
            style={
              location.pathname === "/leaflet/leafletList"
                ? { background: "#CCDAE0", borderRadius: "6px" }
                : {}
            }
            className={` nav-item `}
          >
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/leaflet/leafletList"
            >
              <OverlayTrigger
                placement={mode === "ltr" ? "right" : "left"}
                overlay={<Tooltip>{t("sidebar.sidebarItem13")}</Tooltip>}
              >
                <i className="icon">
                  <BsImages className="text-dark" />
                </i>
              </OverlayTrigger>
              <span
                className="item-name text-black"
                style={{ fontWeight: "600" }}
              >
                {t("sidebar.sidebarItem13")}
              </span>
            </Link>
          </li>
        )}*/}

        <li
          style={
            location.pathname === "/appsettings"
              ? { background: "#CCDAE0", borderRadius: "6px" }
              : {}
          }
          className={`nav-item `}
        >
          <Link className={`nav-link`} aria-current="page" to="/appsettings">
            <OverlayTrigger
              placement={mode === "ltr" ? "right" : "left"}
              overlay={<Tooltip>{t("sidebar.sidebarItem12")}</Tooltip>}
            >
              <i className="icon">
                <IoSettingsSharp className="text-dark" />
              </i>
            </OverlayTrigger>
            <span className="item-name text-black" style={{ fontWeight: "600" }}>
              {t("sidebar.sidebarItem12")}
            </span>
          </Link>
        </li>

      </Accordion>
    </Fragment>
  );
});

VerticalNav.displayName = "VerticalNav";
export default VerticalNav;
